import axios from 'axios';
import { navigate } from '../navigation';
import {
    getAuthAreaFromSession,
    getTokenFromLocalStorage,
    removeTokenFromLocalStorage,
    setTokenInLocalStorage,
} from '../utils/localStorageHelpers';

const fallbackApiServerUrl =
    process.env.NODE_ENV === 'development'
        ? 'http://localhost:3000/api/'
        : 'https://api.astm.koala-hse.it/api/';

const apiServerUrl = process.env.REACT_APP_API_BASE_URL || fallbackApiServerUrl;

const api = axios.create({
    baseURL: apiServerUrl,
    withCredentials: true,
    headers: {
        'Content-type': 'application/json',
    },
});

//response: aggiorna token se presente
api.interceptors.request.use((config) => {
    config.headers = config.headers || {};
    if (!config.headers.Authorization) {
        const token = getTokenFromLocalStorage();
        if (token) {
            config.headers.Authorization = `Bearer ${token}`;
        }
    }

    return config;
});

api.interceptors.response.use(
    (response) => {
        const newToken = response.headers['x-access-token'];
        if (newToken) {
            setTokenInLocalStorage(newToken);
        }
        return response;
    },
    (error) => {
        if (error?.response?.status === 401) {
            const authArea = getAuthAreaFromSession();
            removeTokenFromLocalStorage(authArea);
            const loginPath =
                authArea === 'medico'
                    ? '/AreaMedico/Login'
                    : authArea === 'lavoratore'
                      ? '/AreaLavoratore/Login'
                      : '/Login';
            navigate(loginPath, { replace: true });
        }
        return Promise.reject(error);
    }
);

export default api;
